function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { EntityType } from 'invision-core/src/components/metadata/entityDetails/entity.details.constants';
import { LastRouteSelector } from 'invision-core/src/components/session/session.selectors';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import isEmpty from 'ramda/src/isEmpty';
import merge from 'ramda/src/mergeRight';
import omit from 'ramda/src/omit';
import pathOr from 'ramda/src/pathOr';
import prop from 'ramda/src/prop';
import uniqBy from 'ramda/src/uniqBy';
import { stateGo } from 'redux-ui-router';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { DASHBOARD_ROUTE } from '../../../../reducers/constants/dashboard.constants';
import { MetadataActions, MetadataSelectors } from 'invision-core';
import { retrieveUsageCaps, updateUsageCapsDetails, updateUsageCapsElections } from '../../../../reducers/actions/customer.usage.caps.actions';
import { setSelectAccountLevel } from '../../../../reducers/actions/services.actions';
import { CurrentCustomerIdSelector, CurrentServiceIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { AccountLevelPlanUsageCaps, AccountLevelUsageCaps, AccountLevelUsageNotification, IsUpdatingUsageCapSelector, IsUsageCapsElectionDisabledSelector, IsUsageCapsEnabledSelector, MappedPlanUsageCapsSelector, MappedUsageCapsSelector, MappedUsageNotificationEnabledSelector, NoUsageCapsMessageSelectors, RetrievedUsageCaps, SelectedAccountLevelSelector, UsageCapsElectionsSelector } from '../../../../reducers/selectors/usage.caps.selectors';
import { USAGE_CAP_BEHAVIOR_TYPES, USAGE_CAPS_ELECTION_LEVEL, USAGE_CAPS_THRESHOLD_EXTRA_PROPS, USAGE_CAPS_URL, USAGE_CONTROL_TABS, USAGE_NOTIFICATION_METHOD } from './usage.caps.constants';
export var UsageCapsController = /*#__PURE__*/function () {
  function UsageCapsController($ngRedux, uiNotificationService) {
    _classCallCheck(this, UsageCapsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CoreLocaleKeys: CoreLocaleKeys,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      dashboardUrl: DASHBOARD_ROUTE,
      onTabSelected: this.onTabSelected.bind(this),
      showServiceLevelUsageNotificationsHeader: false,
      showServiceLevelUsageCapsHeader: false,
      stateOrName: USAGE_CAPS_URL,
      uiNotificationService: uiNotificationService,
      usageCapBehaviorTypes: USAGE_CAP_BEHAVIOR_TYPES,
      usageControlTabs: USAGE_CONTROL_TABS,
      closeUsageCapsMessage: this.closeUsageCapsMessage.bind(this)
    });
  }
  return _createClass(UsageCapsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.mappedUsageCaps = [];
      this.usageCapsElections = [];
      this.pageTitle = '';
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          allServicesUsageCaps: AccountLevelUsageCaps(store),
          allServicesPlanUsageCaps: AccountLevelPlanUsageCaps(store),
          allServicesUsageNotification: AccountLevelUsageNotification(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          isUsageCapsElectionDisabled: IsUsageCapsElectionDisabledSelector(store),
          isUsageCapsEnabled: IsUsageCapsEnabledSelector(store),
          isRetrievingUsageCaps: RetrievedUsageCaps.isFetchingDataSelector(store),
          isAccountLevelSelected: SelectedAccountLevelSelector(store),
          isServiceAttributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          isUnitOfMeasurementLoaded: MetadataCodeLoadedSelector(CODES.UnitsOfMeasure, store),
          isUpdatingUsageCaps: IsUpdatingUsageCapSelector(store),
          lastRoute: LastRouteSelector(store),
          mappedPlanUsageCaps: MappedPlanUsageCapsSelector(store),
          mappedUsageCaps: MappedUsageCapsSelector(store),
          mappedUsageNotification: MappedUsageNotificationEnabledSelector(store),
          pricingPlanDetailsMap: MetadataSelectors.entityDetails.PricingPlanDetailsDictionarySelector(store),
          noUsageCapsMenuMessage: NoUsageCapsMessageSelectors(store),
          serviceId: CurrentServiceIdSelector(store),
          retrievedUsageCaps: RetrievedUsageCaps.dataSelector(store),
          unitOfMeasures: MetadataCodeTypeDictionarySelector(CODES.UnitsOfMeasure, store),
          usageCapsElections: UsageCapsElectionsSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        retrieveEntityDetails: MetadataActions.entityDetails.retrieveEntityDetails,
        retrieveUsageCaps: retrieveUsageCaps,
        stateGo: stateGo,
        updateUsageCapsElections: updateUsageCapsElections,
        updateUsageCapsDetails: updateUsageCapsDetails,
        setSelectAccountLevel: setSelectAccountLevel
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.isServiceAttributesLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.ServiceAttribute);
      }
      if (!this.state.isUnitOfMeasurementLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.UnitsOfMeasure);
      }
      this.actions.retrieveUsageCaps(this.state.currentCustomerId, null).then(function () {
        _this.allServicesUsageCaps = _this.state.allServicesUsageCaps.asMutable({
          deep: true
        });
        _this.allServicesPlanUsageCaps = _this.state.allServicesPlanUsageCaps.asMutable({
          deep: true
        });
        _this.allServicesUsageNotification = _this.state.allServicesUsageNotification.asMutable({
          deep: true
        });
        _this.mappedUsageCaps = _this.state.mappedUsageCaps.asMutable({
          deep: true
        });
        _this.mappedPlanUsageCaps = _this.state.mappedPlanUsageCaps.asMutable({
          deep: true
        });
        _this.mappedUsageNotification = _this.state.mappedUsageNotification.asMutable({
          deep: true
        });
        _this.usageCapsElections = _this.state.usageCapsElections.asMutable({
          deep: true
        });
        _this.pageTitle = _this.getUsageCapsPageTitle();
        _this.showServiceLevelUsageCapsHeader = Object.keys(_this.mappedUsageCaps).length;
        _this.showPlanUsageCapsHeader = Object.keys(_this.mappedPlanUsageCaps).length;
        _this.showServiceLevelUsageNotificationsHeader = Object.keys(_this.mappedUsageNotification).length;
        _this.retrieveMappedPricingPlanDetails();
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {});
      this.termsAndConditionsPopUp = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.termsAndConditionsPopUp = api;
        }
      };
      this.changeUsageCapMessagePopUp = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.changeUsageCapMessagePopUp = evt.api;
        }
      };
      if (this.state.isAccountLevelSelected) {
        this.tabs = [{
          id: USAGE_CONTROL_TABS.ACCOUNT_LEVEL,
          name: i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.ACCOUNT_LEVEL),
          active: true
        }];
      } else {
        this.tabs = [{
          id: USAGE_CONTROL_TABS.SERVICE_LEVEL,
          name: i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.SERVICE_LEVEL),
          active: true
        }, {
          id: USAGE_CONTROL_TABS.ACCOUNT_LEVEL,
          name: i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.ACCOUNT_LEVEL),
          active: false
        }];
      }
      this.usageCapBehaviorTypeText = this.getCapBehavior();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.setSelectAccountLevel(false);
      this.disconnectRedux();
    }
  }, {
    key: "onTabSelected",
    value: function onTabSelected(selectedTab) {
      this.tabs = this.tabs.map(function (tab) {
        tab.active = selectedTab.id === tab.id;
        return tab;
      });
    }
  }, {
    key: "openTermsAndConditionsPopUp",
    value: function openTermsAndConditionsPopUp(usageCapTermsAndConditions) {
      this.currentTermsAndConditions = usageCapTermsAndConditions;
      this.termsAndConditionsPopUp.open();
    }
  }, {
    key: "closeTermsAndConditionsPopUp",
    value: function closeTermsAndConditionsPopUp() {
      this.currentTermsAndConditions = {};
      this.termsAndConditionsPopUp.close();
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.state.isRetrievingUsageCaps || this.state.isUpdatingUsageCaps;
    }
  }, {
    key: "retrieveMappedPricingPlanDetails",
    value: function retrieveMappedPricingPlanDetails() {
      if (Object.values(this.mappedPlanUsageCaps).length) {
        var pricingPlanIds = [];
        Object.values(this.mappedPlanUsageCaps).forEach(function (cap) {
          cap.forEach(function (item) {
            if (item.PricingPlanId) {
              pricingPlanIds.push({
                Value: item.PricingPlanId
              });
            }
          });
        });
        this.actions.retrieveEntityDetails(EntityType.PricingPlan, uniqBy(prop('Value'), pricingPlanIds));
      }
      if (this.allServicesPlanUsageCaps.length) {
        var _pricingPlanIds = this.allServicesPlanUsageCaps.map(function (_ref2) {
          var PricingPlanId = _ref2.PricingPlanId;
          return {
            Value: PricingPlanId
          };
        });
        this.actions.retrieveEntityDetails(EntityType.PricingPlan, uniqBy(prop('Value'), _pricingPlanIds));
      }
    }
  }, {
    key: "getUsageCapsPageTitle",
    value: function getUsageCapsPageTitle() {
      var serviceKeys = Object.keys(this.state.mappedUsageCaps);
      var serviceKeysLength = serviceKeys.length;
      //Showing Service number when viewing a specific service or having only 1 service under 'All Services' section
      if (this.state.isAccountLevelSelected) {
        return i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CONTROLS_LABEL);
      } else if (serviceKeysLength === 1 || serviceKeysLength <= 1 && this.state.serviceId) {
        var serviceId = this.state.serviceId || serviceKeys[0];
        return i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.SINGLE_SERVICE_TITLE, {
          serviceId: pathOr(serviceId, [serviceId, 0, 'ServiceIdentifier', 'FormattedValue'], this.state.mappedUsageCaps)
        });
      }
      return i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAP_SETTINGS);
    }
  }, {
    key: "getUomShortName",
    value: function getUomShortName(uomCode) {
      var unitCode = this.state && this.state.unitOfMeasures[uomCode];
      return unitCode && (unitCode.AdditionalProperties.short_name || unitCode.Name) || '';
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent(usageCap) {
      if (usageCap.UsageCapUsageNotification.NotificationMethod === USAGE_NOTIFICATION_METHOD.BY_INCREMENTAL_VALUE && usageCap.UsageCapUsageNotification.NumberOfResets) {
        return i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.NOTIFICATION_TOOLTIP_BY_INCREMENTAL_VALUE_LIMITED_RESETS, {
          sendNotificationEvery: usageCap.UsageCapUsageNotification.SendNotificationEvery,
          notificationEveryUoM: this.getUomShortName(usageCap.UsageCapUsageNotification.SendNotificationEveryUoM),
          resetCount: usageCap.UsageCapUsageNotification.NumberOfResets
        });
      } else if (usageCap.UsageCapUsageNotification.NotificationMethod === USAGE_NOTIFICATION_METHOD.BY_INCREMENTAL_VALUE && !usageCap.UsageCapUsageNotification.NumberOfResets) {
        return i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.NOTIFICATION_TOOLTIP_BY_INCREMENTAL_VALUE_UNLIMITED_RESETS, {
          sendNotificationEvery: usageCap.UsageCapUsageNotification.SendNotificationEvery,
          notificationEveryUoM: this.getUomShortName(usageCap.UsageCapUsageNotification.SendNotificationEveryUoM)
        });
      } else if (usageCap.UsageCapUsageNotification.NotificationMethod === USAGE_NOTIFICATION_METHOD.PERCENTAGE) {
        return i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.NOTIFICATION_TOOLTIP_PERCENTAGE);
      }
    }
  }, {
    key: "getCapBehavior",
    value: function getCapBehavior() {
      return _defineProperty(_defineProperty(_defineProperty({}, this.usageCapBehaviorTypes.DiscountToZero, i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.DISCOUNT_TO_ZERO)), this.usageCapBehaviorTypes.RestrictUsage, i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.RESTRICT_USAGE)), this.usageCapBehaviorTypes.ProcessPayment, i18n.translate(this.CustomerCareLocaleKeys.USAGE_CAPS.PROCESS_PAYMENT));
    }
  }, {
    key: "closeUsageCapsMessage",
    value: function closeUsageCapsMessage() {
      this.changeUsageCapMessagePopUp.close();
    }
  }, {
    key: "emptyCheck",
    value: function emptyCheck(val) {
      return isEmpty(val);
    }

    //Overwrite services when All Services properties are changed
  }, {
    key: "overwriteIndividualServices",
    value: function overwriteIndividualServices(usageCap) {
      var _this2 = this;
      var activate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var electedThreshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : usageCap.ElectedThreshold;
      var toActivate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!activate && toActivate) {
        this.changeUsageCapMessagePopUp.open();
      }
      if (usageCap) {
        var filterCorrespondingUsageCaps = function filterCorrespondingUsageCaps(usageCapElection) {
          return usageCapElection.Id === usageCap.Id && usageCapElection.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL;
        };
        var filterCorrespondingCustomerUsageCaps = function filterCorrespondingCustomerUsageCaps(usageCapElection) {
          return usageCapElection.Id === usageCap.Id && usageCapElection.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.CUSTOMER_LEVEL;
        };
        var overwrittenUsageCaps = this.usageCapsElections.filter(filterCorrespondingUsageCaps).map(function (usageCapElection) {
          return merge(usageCapElection, {
            Elected: false
          });
        });
        var overwrittenCustomerUsageCaps = this.usageCapsElections.filter(filterCorrespondingCustomerUsageCaps).map(function (usageCapElection) {
          return merge(usageCapElection, {
            Elected: activate !== undefined ? activate : usageCapElection.Elected,
            ElectedThreshold: electedThreshold ? electedThreshold : usageCapElection.ElectedThreshold
          });
        });
        overwrittenUsageCaps.forEach(function (overwrittenUsageCap) {
          var getUsageCapIndex = function getUsageCapIndex(usageCapElection) {
            return usageCapElection.Id === overwrittenUsageCap.Id && usageCapElection.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL && usageCapElection.ServiceIdentifier.Value === overwrittenUsageCap.ServiceIdentifier.Value;
          };
          var modifiedCapIndex = _this2.usageCapsElections.findIndex(getUsageCapIndex, {
            overwrittenUsageCap: overwrittenUsageCap
          });
          //TODO: omit extra properties for the UI (displayName, selected)
          _this2.usageCapsElections[modifiedCapIndex] = overwrittenUsageCap;
        });
        overwrittenCustomerUsageCaps.forEach(function (overwrittenUsageCap) {
          var getUsageCapIndex = function getUsageCapIndex(usageCapElection) {
            return usageCapElection.Id === overwrittenUsageCap.Id && usageCapElection.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.CUSTOMER_LEVEL;
          };
          var modifiedCapIndex = _this2.usageCapsElections.findIndex(getUsageCapIndex, {
            overwrittenUsageCap: overwrittenUsageCap
          });
          //TODO: omit extra properties for the UI (displayName, selected)
          _this2.usageCapsElections[modifiedCapIndex] = overwrittenUsageCap;
        });
        this.actions.updateUsageCapsDetails(this.usageCapsElections).then(function () {
          _this2.mappedUsageCaps = _this2.state.mappedUsageCaps.asMutable({
            deep: true
          });
          _this2.allServicesUsageCaps = _this2.state.allServicesUsageCaps.asMutable({
            deep: true
          });
          _this2.allServicesUsageNotification = _this2.state.allServicesUsageNotification.asMutable({
            deep: true
          });
        });
      }
    }
  }, {
    key: "updateUsageCapsDetails",
    value: function updateUsageCapsDetails(usageCap) {
      var _this3 = this;
      if (usageCap) {
        var getUsageCapIndex = function getUsageCapIndex(usageCapElection) {
          return usageCapElection.Id === usageCap.Id && usageCapElection.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL && usageCapElection.ServiceIdentifier.Value === usageCap.ServiceIdentifier.Value;
        };
        var modifiedCapIndex = this.usageCapsElections.findIndex(getUsageCapIndex);
        //TODO: omit extra properties for the UI (displayName, selected)
        this.usageCapsElections[modifiedCapIndex] = usageCap;
        var getCustomerUsageCapIndex = function getCustomerUsageCapIndex(usageCapElection) {
          return usageCapElection.Id === usageCap.Id && usageCapElection.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.CUSTOMER_LEVEL;
        };
        //TODO: omit extra properties for the UI (displayName, selected)
        this.actions.updateUsageCapsDetails(this.usageCapsElections).then(function () {
          _this3.allServicesUsageCaps = _this3.state.allServicesUsageCaps.asMutable({
            deep: true
          });
          _this3.allServicesUsageNotification = _this3.state.allServicesUsageNotification.asMutable({
            deep: true
          });
        });
      }
    }
  }, {
    key: "applyUsageCapsElections",
    value: function applyUsageCapsElections() {
      var _this4 = this;
      if (this.usageCapsElections) {
        var mappedUsageCaps = this.usageCapsElections.map(function (usageCapElection) {
          var Id = usageCapElection.Id,
            ServiceIdentifier = usageCapElection.ServiceIdentifier,
            _usageCapElection$Ele = usageCapElection.Elected,
            Elected = _usageCapElection$Ele === void 0 ? false : _usageCapElection$Ele,
            ElectedThreshold = usageCapElection.ElectedThreshold,
            ElectionLevel = usageCapElection.ElectionLevel;
          return {
            Id: Id,
            ServiceIdentifier: ServiceIdentifier,
            Elected: Elected,
            ElectionLevel: ElectionLevel,
            ElectedThreshold: Elected && (!(usageCapElection !== null && usageCapElection !== void 0 && usageCapElection.UsageNotificationEnabled) || usageCapElection !== null && usageCapElection !== void 0 && usageCapElection.UsageCapEnabled) ? omit(USAGE_CAPS_THRESHOLD_EXTRA_PROPS, ElectedThreshold) : undefined
          };
        });
        this.actions.updateUsageCapsElections(this.state.currentCustomerId, {
          'UsageCapElections': mappedUsageCaps
        }).then(function () {
          _this4.uiNotificationService.success(i18n.translate(_this4.CustomerCareLocaleKeys.USAGE_CAPS.UPDATE_SUCCESS));
          _this4.UsageCapDetailsForm.$setPristine();
          _this4.goBack();
        }).catch(function (error) {
          _this4.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "showIndividualServicesHeader",
    value: function showIndividualServicesHeader() {
      return this.state.mappedUsageCaps && Object.keys(this.state.mappedUsageCaps).length > 1;
    }
  }, {
    key: "goBack",
    value: function goBack() {
      var route = this.state.lastRoute.name || this.dashboardUrl;
      var params = this.state.lastRoute.params || {};
      this.actions.stateGo(route, params);
    }
  }]);
}();
export default {
  template: require('./usage.caps.html'),
  controller: UsageCapsController,
  controllerAs: 'UsageCaps'
};